import React, { useRef, useState } from "react";

const MAX_CHARS = 5000;
const COUNTER_THRESHOLD = 1500;

export default function ChatInput({ onSend, disabled }) {
  const [value, setValue] = useState("");
  const textareaRef = useRef(null);
  const remaining = MAX_CHARS - value.length;
  const isOverLimit = value.length > MAX_CHARS;

  const handleSubmit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled || isOverLimit) return;
    onSend(trimmed);
    setValue("");
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleInput = () => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, 120)}px`;
  };

  return (
    <div className="chat-input-bar">
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
        <textarea
          ref={textareaRef}
          className="chat-input-textarea"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onInput={handleInput}
          placeholder="Type a message... (Enter to send)"
          disabled={disabled}
          rows={1}
          aria-label="Chat message input"
          aria-invalid={isOverLimit}
        />
        {value.length > COUNTER_THRESHOLD && (
          <div
            style={{
              fontSize: 11,
              textAlign: "right",
              color: isOverLimit ? "#A32D2D" : "#888780",
              paddingRight: 4,
            }}
          >
            {isOverLimit
              ? `Message too long — please shorten by ${Math.abs(remaining)} characters`
              : `${remaining} characters remaining`}
          </div>
        )}
      </div>
      <button
        className="chat-input-send-btn"
        onClick={handleSubmit}
        disabled={!value.trim() || disabled || isOverLimit}
        aria-label="Send message"
        type="button"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        </svg>
      </button>
    </div>
  );
}
